"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOP_TREE_ROOT_PATH = exports.CATEGORY_TREE_ROOT_PATHS = void 0;
exports.getTopicType = getTopicType;
exports.CATEGORY_TREE_ROOT_PATHS = [
    "/bokgrupper",
    "/etiketter",
    "/aldersgrupper",
    "/kategorier",
];
exports.SHOP_TREE_ROOT_PATH = "/nettbutikker";
function getTopicType(path) {
    if (path.includes(exports.SHOP_TREE_ROOT_PATH))
        return "shop";
    if (exports.CATEGORY_TREE_ROOT_PATHS.some((categoryPath) => path.includes(categoryPath))) {
        return "category";
    }
    if (path.includes("/priser")) {
        return "prize";
    }
    return "tag";
}
